import React from "react";

export default function Pop({ title, closeHandler, children }) {
  return (







    <div data-a="target0" className="p0 shown">




      <div data-a="trigger" className="pz shown"
        onClick={() => closeHandler()}
      />


      <div className="p_scroll">
        <div data-a="target" className="l_pop_body">


          <div className="l_pop_width">
            <div className="l_pop_top">
              <div className="l_pop_title">
                {title}
              </div>
              <div className="l_pop_right">
                <div className="l_pop_close" onClick={() => closeHandler()}>
                  <div className="ico">
                    <div>close</div>
                  </div>
                </div>
              </div>
            </div>
          </div>




            {children}

          {/* <div className="l_pop_footer" /> */}
        </div>
      </div>



    </div>
  );
}
